import React from 'react';
import { Container, Form, Col } from 'react-bootstrap';
import TopNav from '../nav/TopNav';
import RecordLabelNav from './RecordLabelNav';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledButton = styled.div`
  width: 20%;
`;

const RecordSubmissions = ({ borderStyles }) => {
  return (
    <Container fluid className='RecordSubmissions-background'>
      <TopNav />
      <RecordLabelNav />
      <div className='RecordSubmissions'>
        <Container>
          <div className=' col-lg-10 pl-0 py-3 text-light RecordSubmissions-form'>
            <div className='mx-0 my-2'>
              <span className='text-capitalize h3 pl-0 pb-4'>
                submit your demo
              </span>
            </div>
            <Form className='py-3'>
              <Form.Row className='my-3 py-3'>
                <Form.Group as={Col} className='pr-4' controlId='formGridEmail'>
                  <Form.Label>Email</Form.Label>
                  <Form.Control type='email' className={borderStyles} />
                </Form.Group>

                <Form.Group
                  as={Col}
                  className='pl-4'
                  controlId='formGridPassword'
                >
                  <Form.Label>Password</Form.Label>
                  <Form.Control type='password' className={borderStyles} />
                </Form.Group>
              </Form.Row>

              <Form.Row className='my-3'>
                <Form.Group as={Col} className='pr-4' controlId='formGridDemo'>
                  <Form.Label>Demo URL</Form.Label>
                  <Form.Control type='text' className={borderStyles} />
                </Form.Group>

                <Form.Group
                  as={Col}
                  className='pr-0 pl-4'
                  controlId='formGridGenre'
                >
                  <Form.Label>Genre</Form.Label>
                  <Form.Control type='text' className={borderStyles} />
                </Form.Group>
              </Form.Row>

              <Form.Row className='mt-5 mb-2'>
                <Form.Group as={Col} controlId='formGridinfo'>
                  <Form.Label>Info</Form.Label>
                  <textarea
                    rows='1'
                    className={borderStyles}
                    placeholder='tell us about tourself and music area'
                  ></textarea>
                </Form.Group>
              </Form.Row>

              <StyledButton
                variant='success'
                className='btn btn-theam'
                type='submit'
              >
                Submit
              </StyledButton>
            </Form>
          </div>
        </Container>
      </div>
    </Container>
  );
};

RecordSubmissions.defaultProps = {
  borderStyles:
    'border border-top-0 border-right-0 border-left-0 rounded-0 text-light p-0 ',
};
RecordSubmissions.propTypes = {
  borderStyles: PropTypes.string.isRequired,
};
export default RecordSubmissions;
